import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-detail-reject-modal',
  templateUrl: './detail-reject-modal.component.html',
  styleUrl: './detail-reject-modal.component.scss',
})
export class DetailRejectModalComponent {
  open = input<boolean>(false);
  draft = input<string>('');

  closed = output<void>();
  draftChanged = output<string>();
  confirmRequested = output<void>();

  onInput(event: Event): void {
    this.draftChanged.emit((event.target as HTMLTextAreaElement).value);
  }
}
